import { defineAction } from '~/prix'
import { z } from 'zod'
import veterinarianCreateAction from './veterinarianCreate.action.json' with { type: 'json' }
import { veterinarianObject } from '../veterinarianObject'

const veterinarianCreateDefinition = defineAction({
  ...veterinarianCreateAction,

  input: veterinarianObject
    .pick({
      citizenId: true,
      createdAt: true,
      updatedAt: true,
    })
    .extend({ id: veterinarianObject.shape.id.nullish() }),
  output: veterinarianObject.pick({
    id: true,
    code: true,
  }),
})

export default veterinarianCreateDefinition
